import React from 'react';

import { Icon, layout } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdSettings,
  MdChat,
} from 'react-icons/md';
import { FaUserDoctor } from 'react-icons/fa6';
import { GiMedicines } from 'react-icons/gi';
import { FaCodeBranch } from 'react-icons/fa6';
import { MdHomeRepairService } from 'react-icons/md';
import { MdMedicalServices } from 'react-icons/md';
import { BiSolidPackage } from 'react-icons/bi';
import { MdPerson3 } from 'react-icons/md';
import { FaHandHoldingMedical } from 'react-icons/fa6';
import { MdManageAccounts } from 'react-icons/md';
import { CgDatabase } from 'react-icons/cg';
import { IoMdDoneAll } from 'react-icons/io';
import { AiOutlineMedicineBox } from 'react-icons/ai';
import { GrUserAdmin } from 'react-icons/gr';
import { GrTableAdd } from 'react-icons/gr';
import { FaLaptopMedical } from 'react-icons/fa';
import { BsFileMedical } from 'react-icons/bs';
import { LiaUserPlusSolid } from 'react-icons/lia';
import { RiChatFollowUpLine } from 'react-icons/ri';
import { LuUser } from 'react-icons/lu';
import {
  LiaSortAmountUpSolid,
  LiaSortAmountDownAltSolid,
} from 'react-icons/lia';
import { LuFileCheck, LuFileX } from 'react-icons/lu';
import { VscNotebook } from 'react-icons/vsc';
import { LiaFileInvoiceSolid } from 'react-icons/lia';
import { LuFileText } from 'react-icons/lu';
import { AiOutlineIssuesClose } from 'react-icons/ai';
import { BiCommentCheck } from 'react-icons/bi';
import { RiLockPasswordLine } from 'react-icons/ri';
import { RiCoupon3Line } from 'react-icons/ri';
import { MdCall } from 'react-icons/md';
import { MdPhoneCallback } from 'react-icons/md';
import { MdPhoneInTalk } from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import Profile from 'views/admin/profile';
import Lead from 'views/admin/lead';
import SignIn from 'views/auth/signIn';
import MasterDashboard from 'views/master/default';
import Problem from 'views/master/problem';
import Doctor from 'views/master/doctor';
import MedicalList from 'views/master/medicalList';
import AddAppointment from 'views/admin/addAppointment';
import TherapistDetail from 'views/master/therapistDetail';
import Branch from 'views/master/branch';
import Service from 'views/master/carePlans/service';
import Councelor from 'views/master/counselor';
import Package from 'views/master/carePlans/package';
import DoctorDashboard from 'views/doctor/default';
import TotalAppoinment from 'views/doctor/totalAppoinment';
import DoneTreatment from 'views/doctor/dailyTreatment';
import Clinical from 'views/doctor/totalAppoinment/Clinical';
import AdminUser from 'views/master/adminUser/Index';
import Index from 'views/master/diagnosis/Index';
import AllAppointment from 'views/admin/allAppointment/Index';
import AccountInfo from 'views/master/accountInfo/Index';
import GenerateBill from 'views/master/generateBill/Index';
import FileView from 'views/admin/viewLead/FileView';
import Voucher from 'views/master/voucher/Index';
import Charges from 'views/master/charges/Index';
import FollowUp from 'views/master/followup/FollowUp';
import PatientImg from 'views/master/patientImg/PatientImg';
import CounselorDashboard from 'views/counselor/default';
import TherapistDashboard from 'views/therapist/default/Index';
import { compose } from 'redux';
import UserReport from 'views/master/userReport/Index';
import SalesReport from 'views/master/salesReport/Index';
import ServiceReport from 'views/master/serviceReport/Index';
import AppointmentReport from 'views/master/appointmentReport/Index';
import CallLog from 'views/master/callLog/Index';
import PaidAmountReport from 'views/master/paidAmountReport/PaidAmountReport';
import AllFollowUp from 'views/master/followup/AllFollowUp';
import FileCreatedUser from 'views/master/fileCreated/FileCreatedUser';
import FileNotCreatedUser from 'views/master/fileCreated/FileNotCreatedUser';
import EmergencyCode from 'views/master/emergencyCode/EmergencyCode';
import Referral from 'views/Referral';
import ReferralPage from 'views/master/referralPage/ReferralPage';
import Setting from 'views/master/setting/Index';
import IncomingCall from 'views/master/IVR/index';
// import SideDrawer from 'components/chat/SideDrawer';
// import Chat from 'views/master/chat/Chat';
import ChatPage from 'views/master/chat/ChatPage';

const type = localStorage.getItem('type');

const isAuthenticated = localStorage.getItem('isAuthenticated');

let routes = [];

if (!isAuthenticated) {
  routes.push({
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <SignIn />,
  });
}

if (type === 'Receptionist') {
  routes.push(
    {
      name: 'Main Dashboard',
      layout: '/admin',
      path: '/mainDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MainDashboard />,
    },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdManageAccounts width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        {
          name: 'Add Lead',
          layout: '/master',
          icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: (
            <RiChatFollowUpLine width="20px" height="20px" color="inherit" />
          ),
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: (
            <RiChatFollowUpLine width="20px" height="20px" color="inherit" />
          ),
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
      ],
    },
    {
      name: 'IVR',
      layout: '/master',
      icon: (
        <Icon as={MdPhoneCallback} width="20px" height="20px" color="inherit" />
      ),
      path: '/incomingCall',
      component: <IncomingCall />,
      children: [
        {
          name: 'Incoming Call',
          layout: '/master',
          icon: (
            <Icon
              as={MdPhoneInTalk}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: '/incomingCall',
          component: <IncomingCall />,
        },
      ],
    },
    {
      name: 'Frontdesk',
      layout: '/master',
      icon: <LiaUserPlusSolid width="20px" height="20px" color="inherit" />,
      path: '/addAppointment',
      component: <AddAppointment />,
      children: [
        {
          name: 'Add Appointment',
          layout: '/master',
          path: '/addAppointment',
          icon: (
            <FaLaptopMedical
              as={MdPerson}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <AddAppointment />,
        },
        {
          name: 'All Appointment',
          layout: '/master',
          path: '/allAppointment',
          icon: (
            <BsFileMedical
              as={MdPerson}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <AllAppointment />,
        },
        {
          name: 'View Lead',
          layout: '/master',
          icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
          path: '/viewLead/:id',
          component: <FileView />,
        },
      ],
    },
    {
      name: 'Clinical',
      layout: '/master',
      path: '/clinical/:id',
      component: <Clinical />,
    },
    {
      name: 'Patient Image',
      layout: '/master',
      icon: <RiChatFollowUpLine width="20px" height="20px" color="inherit" />,
      path: '/patientImg/:id',
      component: <PatientImg />,
    },
    {
      name: 'Account Info',
      layout: '/master',
      path: '/accountInfo/:id',
      component: <AccountInfo />,
    },
    {
      name: 'Generate Bill',
      layout: '/master',
      path: '/generateBill/:id',
      component: <GenerateBill />,
    },
    {
      name: 'Voucher',
      layout: '/master',
      path: '/voucher/:id',
      component: <Voucher />,
    },
    {
      name: 'View Lead',
      layout: '/master',
      icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
      path: '/viewLead/:id',
      component: <FileView />,
    },
    {
      name: 'Call Log',
      layout: '/master',
      icon: <RiChatFollowUpLine width="20px" height="20px" color="inherit" />,
      path: '/callLog/:id',
      component: <CallLog />,
    },
  );
}

if (type === 'Master') {
  routes.push(
    {
      name: 'Master Dashboard',
      layout: '/master',
      path: '/materDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MasterDashboard />,
    },
    // {
    //   name: 'Chat',
    //   layout: '/master',
    //   path: '/chat',
    //   icon: <Icon as={MdChat} width="20px" height="20px" color="inherit" />,
    //   // component: <SideDrawer />,
    //   // component: <Chat />
    //   component: <ChatPage />,
    // },
    {
      name: 'Frontdesk',
      layout: '/master',
      icon: <LiaUserPlusSolid width="20px" height="20px" color="inherit" />,
      path: '/addAppointment',
      component: <AddAppointment />,
      children: [
        {
          name: 'Add Appointment',
          layout: '/master',
          path: '/addAppointment',
          icon: (
            <FaLaptopMedical
              as={MdPerson}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <AddAppointment />,
        },
        {
          name: 'All Appointment',
          layout: '/master',
          path: '/allAppointment',
          icon: (
            <BsFileMedical
              as={MdPerson}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <AllAppointment />,
        },
      ],
    },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdManageAccounts width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        {
          name: 'Add Lead',
          layout: '/master',
          icon: <LuFileText width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: (
            <RiChatFollowUpLine width="20px" height="20px" color="inherit" />
          ),
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: <BiCommentCheck width="20px" height="20px" color="inherit" />,
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
        {
          name: 'View Lead',
          layout: '/master',
          icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
          path: '/viewLead/:id',
          component: <FileView />,
        },
      ],
    },
    {
      name: 'IVR',
      layout: '/master',
      icon: (
        <Icon as={MdPhoneCallback} width="20px" height="20px" color="inherit" />
      ),
      path: '/incomingCall',
      component: <IncomingCall />,
      children: [
        {
          name: 'Incoming Call',
          layout: '/master',
          icon: (
            <Icon
              as={MdPhoneInTalk}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: '/incomingCall',
          component: <IncomingCall />,
        },
      ],
    },
    {
      name: 'Master',
      layout: '/master',
      icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
      path: '/Consult',
      component: <Problem />,
      children: [
        {
          name: 'Consult',
          layout: '/master',
          icon: (
            <Icon
              as={AiOutlineIssuesClose}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: '/Consult',
          component: <Problem />,
        },
        {
          name: 'Diagnosis',
          layout: '/master',
          path: '/diagnosis',
          icon: (
            <AiOutlineMedicineBox width="20px" height="20px" color="inherit" />
          ),
          component: <Index />,
        },
        {
          name: 'Medicine List',
          layout: '/master',
          path: '/medical-list',
          icon: <GiMedicines width="20px" height="20px" color="inherit" />,
          component: <MedicalList />,
        },
        {
          name: 'Branch',
          layout: '/master',
          path: '/branch',
          icon: <FaCodeBranch width="20px" height="20px" color="inherit" />,
          component: <Branch />,
        },
        {
          name: 'Service',
          layout: '/master',
          path: '/care-plans/service',
          icon: (
            <MdMedicalServices width="20px" height="20px" color="inherit" />
          ),
          component: <Service />,
        },
        {
          name: 'Charges',
          layout: '/master',
          path: '/charges',
          icon: <BiSolidPackage width="20px" height="20px" color="inherit" />,
          component: <Charges />,
        },
        {
          name: 'Clinical',
          layout: '/master',
          path: '/clinical/:id',
          component: <Clinical />,
        },
        {
          name: 'Account Info',
          layout: '/master',
          path: '/accountInfo/:id',
          component: <AccountInfo />,
        },
        {
          name: 'Generate Bill',
          layout: '/master',
          path: '/generateBill/:id',
          component: <GenerateBill />,
        },
        {
          name: 'Voucher',
          layout: '/master',
          path: '/voucher/:id',
          component: <Voucher />,
        },
        {
          name: 'Referral',
          layout: '/master',
          icon: <RiCoupon3Line width="20px" height="20px" color="inherit" />,
          path: '/referral',
          component: <Referral />,
        },
      ],
    },
    {
      name: 'Report',
      layout: '/master',
      icon: (
        <Icon
          as={LiaFileInvoiceSolid}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      path: '/UserList',
      component: <UserReport />,
      children: [
        {
          name: 'User',
          layout: '/master',
          icon: (
            <LuUser
              as={MdBarChart}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: '/UserList',
          component: <UserReport />,
        },
        {
          name: 'Sales',
          layout: '/master',
          icon: (
            <LiaSortAmountUpSolid
              as={MdBarChart}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: '/SalesReport',
          component: <SalesReport />,
        },
        {
          name: 'Paid Amount',
          layout: '/master',
          icon: (
            <Icon
              as={LiaSortAmountUpSolid}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: '/PaidAmountReport',
          component: <PaidAmountReport />,
        },
        {
          name: 'Due Amount',
          layout: '/master',
          icon: (
            <Icon
              as={LiaSortAmountDownAltSolid}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: '/DueAmount',
          component: <ServiceReport />,
        },
        {
          name: 'Appointment',
          layout: '/master',
          icon: (
            <Icon as={VscNotebook} width="20px" height="20px" color="inherit" />
          ),
          path: '/AppointmentReport',
          component: <AppointmentReport />,
        },
        {
          name: 'File Created',
          layout: '/master',
          icon: (
            <Icon as={LuFileCheck} width="20px" height="20px" color="inherit" />
          ),
          path: '/FileCreated',
          component: <FileCreatedUser />,
        },
        {
          name: 'File Not Created',
          layout: '/master',
          icon: (
            <Icon as={LuFileX} width="20px" height="20px" color="inherit" />
          ),
          path: '/FileNotCreated',
          component: <FileNotCreatedUser />,
        },
      ],
    },
    {
      name: 'Patient Image',
      layout: '/master',
      icon: <RiChatFollowUpLine width="20px" height="20px" color="inherit" />,
      path: '/patientImg/:id',
      component: <PatientImg />,
    },
    {
      name: 'Call Log',
      layout: '/master',
      icon: <RiChatFollowUpLine width="20px" height="20px" color="inherit" />,
      path: '/callLog/:id',
      component: <CallLog />,
    },
    {
      name: 'Admin User',
      layout: '/master',
      icon: <GrUserAdmin width="20px" height="20px" color="inherit" />,
      path: '/adminUser',
      component: <AdminUser />,
    },
    {
      name: 'Emergency Code',
      layout: '/master',
      icon: <RiLockPasswordLine width="20px" height="20px" color="inherit" />,
      path: '/emergencyCode',
      component: <EmergencyCode />,
    },
    {
      name: 'Referral Page',
      layout: '/master',
      icon: <RiLockPasswordLine width="20px" height="20px" color="inherit" />,
      path: '/referralPage/:id',
      component: <ReferralPage />,
    },
    {
      name: 'Setting',
      layout: '/master',
      path: '/Setting',
      icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
      component: <Setting />,
    },
  );
}

if (type === 'Doctor') {
  routes.push(
    {
      name: 'Doctor Dashboard',
      layout: '/doctor',
      path: '/doctorDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <DoctorDashboard />,
    },
    {
      name: 'Today Appoinment',
      layout: '/doctor',
      path: '/totalAppoinment',
      icon: <CgDatabase width="20px" height="20px" color="inherit" />,
      component: <TotalAppoinment />,
    },
    {
      name: ' All Appointment',
      layout: '/doctor',
      path: '/allTreatment',
      icon: <IoMdDoneAll width="20px" height="20px" color="inherit" />,
      component: <DoneTreatment />,
    },
    {
      name: 'Clinical',
      layout: '/doctor',
      path: '/clinical/:id',
      component: <Clinical />,
    },
    {
      name: 'Account Info',
      layout: '/master',
      path: '/accountInfo/:id',
      component: <AccountInfo />,
    },
    {
      name: 'Generate Bill',
      layout: '/master',
      path: '/generateBill/:id',
      component: <GenerateBill />,
    },
    {
      name: 'Patient Image',
      layout: '/master',
      icon: <RiChatFollowUpLine width="20px" height="20px" color="inherit" />,
      path: '/patientImg/:id',
      component: <PatientImg />,
    },
  );
}

if (type === 'Counselors') {
  routes.push(
    {
      name: 'Counselor Dashboard',
      layout: '/counselor',
      path: '/counselorDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <CounselorDashboard />,
    },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdManageAccounts width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        {
          name: 'Add Lead',
          layout: '/master',
          icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: (
            <RiChatFollowUpLine width="20px" height="20px" color="inherit" />
          ),
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: (
            <RiChatFollowUpLine width="20px" height="20px" color="inherit" />
          ),
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
      ],
    },
    {
      name: 'IVR',
      layout: '/master',
      icon: (
        <Icon as={MdPhoneCallback} width="20px" height="20px" color="inherit" />
      ),
      path: '/incomingCall',
      component: <IncomingCall />,
      children: [
        {
          name: 'Incoming Call',
          layout: '/master',
          icon: (
            <Icon
              as={MdPhoneInTalk}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: '/incomingCall',
          component: <IncomingCall />,
        },
      ],
    },
    {
      name: 'Frontdesk',
      layout: '/master',
      icon: <LiaUserPlusSolid width="20px" height="20px" color="inherit" />,
      path: '/addAppointment',
      component: <AddAppointment />,
      children: [
        {
          name: 'Add Appointment',
          layout: '/master',
          path: '/addAppointment',
          icon: (
            <FaLaptopMedical
              as={MdPerson}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <AddAppointment />,
        },
        {
          name: 'All Appointment',
          layout: '/master',
          path: '/allAppointment',
          icon: (
            <BsFileMedical
              as={MdPerson}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <AllAppointment />,
        },
      ],
    },
    {
      name: 'Clinical',
      layout: '/master',
      path: '/clinical/:id',
      component: <Clinical />,
    },
    {
      name: 'Patient Image',
      layout: '/master',
      icon: <RiChatFollowUpLine width="20px" height="20px" color="inherit" />,
      path: '/patientImg/:id',
      component: <PatientImg />,
    },
    {
      name: 'Account Info',
      layout: '/master',
      path: '/accountInfo/:id',
      component: <AccountInfo />,
    },
    {
      name: 'Generate Bill',
      layout: '/master',
      path: '/generateBill/:id',
      component: <GenerateBill />,
    },
    {
      name: 'Voucher',
      layout: '/master',
      path: '/voucher/:id',
      component: <Voucher />,
    },
    {
      name: 'Call Log',
      layout: '/master',
      icon: <RiChatFollowUpLine width="20px" height="20px" color="inherit" />,
      path: '/callLog/:id',
      component: <CallLog />,
    },
    {
      name: 'View Lead',
      layout: '/master',
      icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
      path: '/viewLead/:id',
      component: <FileView />,
    },
  );
}

if (type === 'Therapist') {
  routes.push(
    {
      name: 'Therapist Dashboard',
      layout: '/therapist',
      path: '/therapistDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <TherapistDashboard />,
    },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdManageAccounts width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        {
          name: 'Add Lead',
          layout: '/master',
          icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
      ],
    },
    {
      name: 'Frontdesk',
      layout: '/master',
      icon: <LiaUserPlusSolid width="20px" height="20px" color="inherit" />,
      path: '/addAppointment',
      component: <AddAppointment />,
      children: [
        {
          name: 'Add Appointment',
          layout: '/master',
          path: '/addAppointment',
          icon: (
            <FaLaptopMedical
              as={MdPerson}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <AddAppointment />,
        },
        {
          name: 'All Appointment',
          layout: '/master',
          path: '/allAppointment',
          icon: (
            <BsFileMedical
              as={MdPerson}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <AllAppointment />,
        },
      ],
    },
    {
      name: 'Clinical',
      layout: '/master',
      path: '/clinical/:id',
      component: <Clinical />,
    },
    {
      name: 'Account Info',
      layout: '/master',
      path: '/accountInfo/:id',
      component: <AccountInfo />,
    },
    {
      name: 'Generate Bill',
      layout: '/master',
      path: '/generateBill/:id',
      component: <GenerateBill />,
    },
    {
      name: 'Voucher',
      layout: '/master',
      path: '/voucher/:id',
      component: <Voucher />,
    },
    {
      name: 'Patient Image',
      layout: '/master',
      icon: <RiChatFollowUpLine width="20px" height="20px" color="inherit" />,
      path: '/patientImg/:id',
      component: <PatientImg />,
    },
  );
}

if (type === 'Lead') {
  routes.push(
    {
      name: 'Main Dashboard',
      layout: '/admin',
      path: '/mainDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MainDashboard />,
    },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdManageAccounts width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        {
          name: 'Add Lead',
          layout: '/master',
          icon: <LuFileText width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
      ],
    },
  );
}

export default routes;
